import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

interface LinkProps {
    text: string;
    destination: string;
    className?: string;
}

const isAbsolute = (url: string) => /^https?:\/\//i.test(url);

const NavLink: React.FC<React.PropsWithChildren<LinkProps>> = ({
    text,
    destination,
    className,
}) => {
    if (isAbsolute(destination)) {
        return (
            <StyledAnchor
                className={className}
                href={destination}
                rel="noopener"
            >
                {text}
            </StyledAnchor>
        );
    }

    return (
        <StyledLink className={className} to={destination}>
            {text}
        </StyledLink>
    );
};

export default NavLink;

const baseStyles = `
  color: ${aampeTheme.colors.solidA01};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-decoration: none;
`;

const StyledLink = styled(Link)`
    ${baseStyles}
`;

const StyledAnchor = styled.a`
    ${baseStyles}
`;
